import { Country, Currency } from "@lookiero/sty-psp-locale";
import { Breakpoint, Locale } from "./types";

enum IMAGE_PERSPECTIVE {
  // @see https://github.com/lookiero/catalog-back/blob/2d794574c6166061d467596e577f882475fa47a3/src/main/java/com/lookiero/catalog/pim/domain/media/model/MediaPerspective.java#L3
  MAIN = "MAIN",
  BACK = "BACK",
  COLLAGE = "COLLAGE",
  DETAIL = "DETAIL",
  FRONT = "FRONT",
  FRONT_FAR = "FRONT_FAR",
  INSPIRATIONAL = "INSPIRATIONAL",
  LABEL = "LABEL",
  OTHER = "OTHER",
  SIDE = "SIDE",
}

const LOCALE: Record<Country, Locale> = {
  // @see IETF BCP 47: http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
  BE: "fr-BE",
  DE: "de-DE",
  ES: "es-ES",
  FR: "fr-FR",
  GB: "en-GB",
  IT: "it-IT",
  LU: "fr-LU",
  PT: "pt-PT",
  AT: "de-AT",
  NL: "nl-NL",
  SE: "sv-SE",
  CH: "de-CH",
};

const SCREEN_SIZE: Record<Breakpoint, Breakpoint> = {
  S: "S",
  M: "M",
  L: "L",
};

enum OS {
  WEB = "web",
  ANDROID = "android",
  IOS = "ios",
}

const DEFAULT_COUNTRY_CODE = Country.ES;
const DEFAULT_CURRENCY = Currency.EUR;
const DEFAULT_LOCALE = LOCALE["ES"];
const DEFAULT_SCREEN_SIZE = SCREEN_SIZE["S"];
const CONTENT_MAX_WIDTH = 1280;

export {
  IMAGE_PERSPECTIVE,
  LOCALE,
  SCREEN_SIZE,
  OS,
  DEFAULT_COUNTRY_CODE,
  DEFAULT_CURRENCY,
  DEFAULT_LOCALE,
  DEFAULT_SCREEN_SIZE,
  CONTENT_MAX_WIDTH,
};
